import React from 'react';
import './App.css';
import TextToSpeech from './components/TextToSpeech';
import SpeechToText from './components/SpeechToText';

const App = () =>{
  
 
  return (
    <>
       <TextToSpeech />
       <SpeechToText />
    </>
  )
};

export default App;